import { useState } from "react";
import { averias } from "@/mocks/averias";

interface Props {
  ids?: string[];
  className?: string;
}

const MOBILE_VISIBLE = 3;

export default function AveriasFrecuentesSection({ ids, className }: Props) {
  const [expanded, setExpanded] = useState(false);
  const items = ids
    ? ids.map((id) => averias.find((a) => a.id === id)).filter(Boolean) as typeof averias
    : averias;

  const visibleItems = expanded ? items : items.slice(0, MOBILE_VISIBLE);
  const hasMore = items.length > MOBILE_VISIBLE;

  return (
    <section className={className || "py-10 md:py-14 bg-background-100"}>
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3 font-heading">
            Averías frecuentes y cómo las solucionamos
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            Si reconoces tu problema aquí, no esperes más. La mayoría se arreglan en la misma visita.
          </p>
        </div>
        <div className="space-y-3 md:space-y-4 max-w-4xl mx-auto">
          {visibleItems.map((item) => (
            <div key={item.id} className="bg-background-50 rounded-2xl p-4 md:p-6 border border-background-200/60">
              <div className="flex items-start gap-3 md:gap-4">
                <div className="w-9 h-9 md:w-10 md:h-10 flex-shrink-0 flex items-center justify-center rounded-xl bg-primary-500/10 text-primary-600 mt-0.5">
                  <span className="w-4 h-4 md:w-5 md:h-5 flex items-center justify-center"><i className={`${item.icon} text-base md:text-lg`}></i></span>
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm md:text-lg font-bold text-foreground-900 mb-2">
                    {item.problema}
                  </h3>
                  <div className="space-y-2 text-xs md:text-sm text-foreground-600 leading-relaxed">
                    <p>
                      <strong className="text-foreground-800">¿Por qué ocurre?</strong>{" "}
                      {item.porque}
                    </p>
                    <p className="text-primary-700 font-medium">
                      ¿Tiene solución? Sí, y se arregla en la misma visita en la mayoría de los casos.
                    </p>
                    <p>
                      <strong className="text-foreground-800">Lo que hacemos:</strong>{" "}
                      {item.hacemos}
                    </p>
                  </div>
                  <div className="mt-4 pt-4 border-t border-background-200/60 flex flex-col sm:flex-row gap-3">
                    <a
                      href="tel:+34951120770"
                      className="inline-flex items-center justify-center gap-2 bg-gradient-to-r from-primary-500 to-primary-600 hover:from-primary-600 hover:to-primary-700 text-background-50 font-semibold text-xs md:text-sm px-5 md:px-6 py-3 rounded-full transition-all active:scale-[0.98] whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/15"
                    >
                      <span className="w-4 h-4 flex items-center justify-center"><i className="ri-phone-fill"></i></span>
                      Llama y lo arreglamos — 951 12 07 70
                    </a>
                    <a
                      href="https://wa.me/34627213347"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center justify-center gap-2 bg-[#25D366] hover:bg-[#1faa52] text-white font-semibold text-xs md:text-sm px-5 md:px-6 py-3 rounded-full transition-all active:scale-[0.98] whitespace-nowrap cursor-pointer"
                    >
                      <span className="w-4 h-4 flex items-center justify-center"><i className="ri-whatsapp-fill"></i></span>
                      Pide presupuesto por WhatsApp
                    </a>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {hasMore && (
          <div className="mt-5 text-center">
            <button
              onClick={() => setExpanded(!expanded)}
              className="inline-flex items-center gap-2 px-6 py-3 bg-background-100 hover:bg-background-200 text-foreground-700 font-semibold text-sm rounded-full border border-background-200 transition-all cursor-pointer"
            >
              {expanded ? (
                <>Ver menos <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-up-s-line"></i></span></>
              ) : (
                <>Ver las {items.length} averías <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-down-s-line"></i></span></>
              )}
            </button>
          </div>
        )}
      </div>
    </section>
  );
}